"use client";

import React from "react";
import { Heart, Handshake, Shield } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
const reasons = [{
  title: "Spiritual Growth",
  icon: Heart,
  description: "Deepen your own faith by serving those who paved the way before us. Every visit is an opportunity to share Christ's love, offer a comforting prayer, and experience the profound grace of selfless companionship."
}, {
  title: "Community Bond",
  icon: Handshake,
  description: "Bridge the generational gap and build lasting, meaningful friendships. Your consistent presence reminds isolated seniors that they are valued, remembered, and remain an integral part of our shared community."
}, {
  title: "Crisis Prevention",
  icon: Shield,
  description: "Serve as a vital lifeline for vulnerable individuals in our neighborhoods. By conducting basic needs checks during your visits, you help prevent emergencies and ensure seniors can safely remain in their homes."
}];
export default function WhyVolunteer() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="why-volunteer" className="relative w-full bg-background py-24 lg:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none overflow-hidden flex justify-center">
        <div className="w-[800px] h-[800px] bg-secondary/5 rounded-full blur-3xl -top-40 absolute opacity-50 mix-blend-multiply" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10 max-w-7xl">
        <div ref={headerRef} className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-primary mb-6 tracking-tight">
            Why Volunteer?
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-sans leading-relaxed">
            Discover the profound impact of a single visit. Join our network of
            compassionate individuals dedicated to bringing light into the lives
            of isolated seniors.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 transition-all duration-1000 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {reasons.map((reason, i) => {
          const Icon = reason.icon;
          return <Card key={i} data-index={i} className="bg-card/60 backdrop-blur-md border-border/40 shadow-sm hover:shadow-md transition-all duration-300 group flex flex-col h-full">
                <CardHeader className="pb-4 text-center flex flex-col items-center pt-10">
                  <div className="mb-6 inline-flex items-center justify-center p-5 rounded-full bg-secondary/10 text-secondary group-hover:bg-secondary group-hover:text-secondary-foreground transition-colors duration-300">
                    <Icon strokeWidth={1.25} className="w-12 h-12" />
                  </div>
                  <CardTitle className="font-serif text-2xl text-primary">
                    {reason.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="text-center flex-grow pb-10">
                  <CardDescription className="text-base text-muted-foreground leading-relaxed font-sans">
                    {reason.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}